import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@formrails/environments';

@Injectable({
  providedIn: 'root'
})
export class DocumentApiService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.documentApi}/document`;

  uploadDocument(file: File, fileName: string): Observable<void> {
    const formData = new FormData();
    formData.append('file', file, fileName);
    return this.http.post<void>(this.base, formData);
  }
}
